import React, { useState } from "react";
// ---- Style ---- //
import "./index.scss";
import axios from "axios";
import { saveTokens } from "../../helpers";
import { Link } from "react-router";
// ---- Components ---- //
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;

  const login = async () => {
    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}/owners/login`, {
        login: username,
        password,
      });
      if (response.status === 200) {
        saveTokens(response.data.accessToken, response.data.refreshToken);
        window.location.href = "/";
        return true;
      } else {
        throw new Error("Ошибка авторизации");
      }
    } catch (err) {
      setError("Неверный логин или пароль");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    login();
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Войти в систему</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="login-form__label">Логин</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Введите логин"
              className="login-form__input"
            />
          </div>
          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Введите пароль"
              className="login-form__input"
            />
          </div>
          {error && <div className="error-message">{error}</div>}{" "}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Загрузка..." : "Войти"}
          </button>
        </form>
        <div className="footer">
          <Link to="/forgot-password">Забыли пароль?</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
